import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import DarkModeToggle from './DarkModeToggle';

const Navigation = ({ isDark, onToggleDark }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  return (
    <>
      {/* Dark mode toggle — top right */}
      <div className="fixed top-8 right-8 z-50" data-testid="nav-dark-toggle">
        <DarkModeToggle isDark={isDark} onToggle={onToggleDark} />
      </div>

      {/* Burger pill */}
      <div
        className={`burger-menu ${isOpen ? 'active' : ''}`}
        onClick={toggleMenu}
        data-testid="burger-menu"
        data-cursor-hover
      >
        <span className="burger-icon"></span>
        <span className="text-xs font-medium tracking-widest uppercase" style={{ fontFamily: 'Nohemi, sans-serif' }}>
          {isOpen ? 'Close' : 'Menu'}
        </span>
      </div>

      {/* Fullscreen overlay */}
      <div className={`nav-overlay ${isOpen ? 'active' : ''}`} data-testid="nav-overlay">
        <nav className="nav-menu">
          <Link to="/" onClick={closeMenu} data-testid="nav-home">Home</Link>
          <Link to="/work" onClick={closeMenu} data-testid="nav-work">Work</Link>
          <Link to="/about" onClick={closeMenu} data-testid="nav-about">About</Link>
          <Link to="/contact" onClick={closeMenu} data-testid="nav-contact">Contact</Link>
        </nav>
      </div>
    </>
  );
};

export default Navigation;
